import { IState } from '../../store';
import { getDealType, isRent } from '../../utils/deal_type';
import { CurrencySymbol, getPriceRentTimeSuffix } from '../../utils/formatters';
import { getRentPrice } from '../../utils/price';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { IPriceSelectorOptions } from './types';

export function residentialPriceSelector(state: IState, options: IPriceSelectorOptions = {}): string {
  const {
    excludedUtilitiesTermsRegions,
    offerData: { offer },
  } = state;
  const dealType = getDealType(offer);
  const postfix = getPriceRentTimeSuffix(offer);
  const { useSharePrefix, currencySign: currencySignOption } = options;
  const sharePrefix = useSharePrefix ? 'за ' : '';
  const currencySign = currencySignOption || CurrencySymbol.Rur;

  return isRent(dealType)
    ? getRentPrice(offer, excludedUtilitiesTermsRegions, currencySign)
    : `${sharePrefix}${numberToPrettyString(Math.round(offer.bargainTerms.prices.rur))} ${currencySign}${postfix}`;
}
